import { Loader } from "@app/components/core/Loader/Loader"
import { useGetZones } from "@app/store/service/cmsService"
import ZoneSelector from "./ZoneSelector"

export default function ZoneSelection() {
	const { data: zones, isFetching: fetchingZones } = useGetZones()

	return (
		<div>
			<div className="mb-2 f2">Zone auswählen</div>
			<div>
				<Loader show={fetchingZones} />
				{!fetchingZones && zones && zones.map(zone => <ZoneSelector {...zone} key={zone.zoneId} />)}
			</div>
		</div>
	)
}
